import React, { useEffect, useState } from 'react'

import { useIntl, Link } from 'gatsby-plugin-react-intl'

import * as S from './styled'

function shouldHideBannerOnCurrentPage(hideOnPages = []) {
  return hideOnPages?.some(
    (h) =>
      typeof window !== 'undefined' &&
      (window.location.pathname.endsWith(h?.toLowerCase()) || window.location.pathname.endsWith(`${h?.toLowerCase()}/`))
  )
}

export function AnnouncementBanner({ isActive, strong, text, labelLink, link, hideOnPages }) {
  const intl = useIntl()

  const [isVisibleModal, setIsVisibleModal] = useState(false)

  function colseModal() {
    setIsVisibleModal(false)
    sessionStorage.setItem('isVisibleModal', false)
  }

  useEffect(() => {
    const isVisibleModal = sessionStorage.getItem('isVisibleModal')

    if (isVisibleModal) {
      setIsVisibleModal(false)
    } else {
      setIsVisibleModal(true)
    }
  }, [isVisibleModal])

  if (shouldHideBannerOnCurrentPage(hideOnPages)) {
    return <S.AnnouncementBannerWrapper style={{ background: '#FFFFFF' }} />
  }

  return isActive && intl.locale === 'pt' ? (
    <S.AnnouncementBannerWrapper style={{ background: isVisibleModal && intl.locale === 'pt' ? '#FFF2EE' : '#FFFFFF' }}>
      {isVisibleModal && (
        <S.Container>
          <S.Content>
            <p>
              <strong>{strong}</strong>
              <span>{text}</span>
              <Link to={link}>{labelLink}</Link>
            </p>
          </S.Content>
          <S.CloseModal type="button" onClick={colseModal}>
            <S.CloseIcon />
          </S.CloseModal>
        </S.Container>
      )}
    </S.AnnouncementBannerWrapper>
  ) : (
    <S.AnnouncementBannerWrapper style={{ background: '#FFFFFF' }} />
  )
}
